// Pure helpers for the trust/school default-logo response. Kept free of axios/adminRequest
// imports so they can be unit tested without pulling the HTTP client.

// The Admin default-logo endpoints return the logo object directly (PascalCase),
// e.g. { Id, HeaderLogo }. Tolerate camelCase too.
export const headerLogoOf = res => res?.HeaderLogo || res?.headerLogo || ''
